<template>
  <keep-alive>
    <router-view v-if="$route.meta.keepAlive" :key="$route.path"></router-view>
  </keep-alive>
  <!-- 不缓存的页面，不缓存$route.meta.keepAlive为false的组件 -->
  <router-view v-if="!$route.meta.keepAlive" :key="$route.path"></router-view>
<!--  <router-view style="width: 100%; height: 100%" :key="$route.path"></router-view>-->
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script setup lang="ts">
</script>